import _regenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/Users/peter/Desktop/OA_myyc_Code/oa_ui/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import { request, METHOD } from '@/utils/request';
export function queryNewDocument(_x, _x2, _x3) {
  return _queryNewDocument.apply(this, arguments);
}
function _queryNewDocument() {
  _queryNewDocument = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(page, limit, param) {
    var data;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          // 数据处理
          data = {
            currentNo: page,
            pageSize: limit,
            queryStr: param.title,
            documentId: param.serialNumber,
            cateId: param.cateId,
            status: param.status,
            startDate: param.startDate,
            endDate: param.endDate
          };
          return _context.a(2, request("/newDocument/queryNewDocument", METHOD.POST, data));
      }
    }, _callee);
  }));
  return _queryNewDocument.apply(this, arguments);
}